module.exports = __webpack_public_path__ + "static/media/ua6.52cba865.jpg";